/**
 * Shop All url filtered by the exact color, used by the PDP "Color Detail" link.
 *
 * The query is serialized with `URLSearchParams`, the same way the Algolia router `createURL` does,
 * so the router sees the landing url as unchanged and does not push a second history entry.
 * A `,` in the color is still split into two refinement values by the router.
 */
export const getColorDetailUrl = (colorDescription: string): string =>
  `/shop/all?${new URLSearchParams({ exactColorDescription: colorDescription.toLowerCase() })}`;
